export function mergeObjs(...objs: object[]) {
    const result = {};
    for (const obj of objs) {
        for (const key of Object.keys(obj)) {
            if (result[key] == undefined || typeof result[key] !== "object") {
                result[key] = obj[key];
            }
            else if (typeof result[key] == "object" && typeof obj[key] !== "object") {
                continue;
            }
            else {
                result[key] = mergeObjs(result[key], obj[key])
            }
        }
    }
    return result;
}